import axios from 'axios';
import { API_ROOT, v2Api } from './v2Client';

const LOG = '[SquashAPI matches]';

/** Présence ERP : bool SQL nullable + entiers / chaînes tolérés. */
function normalizePlayerPresent(raw) {
  const v = raw;
  if (v === true || v === 1 || v === '1') return true;
  if (v === false || v === 0 || v === '0') return false;
  if (typeof v === 'string' && v.toLowerCase() === 'true') return true;
  if (typeof v === 'string' && v.toLowerCase() === 'false') return false;
  return false;
}

export function normalizeMatchForScreen(m) {
  const ja = m.joueur_a;
  const jb = m.joueur_b;
  const aPresentRaw = m.player_a_present ?? m.playerAPresent ?? m.joueur_a_present;
  const bPresentRaw = m.player_b_present ?? m.playerBPresent ?? m.joueur_b_present;
  return {
    ...m,
    player_a_id: m.player_a_id ?? m.playerAId ?? ja?.id,
    player_b_id: m.player_b_id ?? m.playerBId ?? jb?.id,
    no_show_player_id:
      m.no_show_player_id ?? m.noshow_player_id ?? m.noshowPlayerId ?? null,
    player_a_present: normalizePlayerPresent(aPresentRaw),
    player_b_present: normalizePlayerPresent(bPresentRaw),
  };
}

/**
 * Aplatit une saison « current » (boxes + matches) en lignes grille ERP (box_name, season_id, etc.).
 * @param {object} season — réponse SeasonCurrentDto (GET /Season/current ou /Season/current_all)
 * @returns {object[]}
 */
export function flattenSeasonCurrentToGridRows(season) {
  const sidRaw = season?.season_id ?? season?.seasonId;
  if (sidRaw == null || sidRaw === '') return [];
  const sid = String(sidRaw);

  const rows = [];
  for (const box of season?.boxes || []) {
    const boxName = box?.name ?? '';
    const boxId = box?.box_id ?? box?.boxId;
    const level = box?.level ?? 0;
    for (const m of box?.matches || []) {
      rows.push(
        normalizeMatchForScreen({
          ...m,
          box_name: m.box_name ?? boxName,
          box_id: m.box_id ?? boxId,
          box_level: m.box_level ?? level,
          season_id: m.season_id ?? sid,
        })
      );
    }
  }
  return rows;
}

/**
 * GET /Season/current_all — toutes les saisons actives (running), avec boxes et matchs.
 * @returns {Promise<{ id: string, label: string, rows: object[] }[]>}
 */
export async function fetchActiveSeasonsMatchBundles() {
  const { data } = await v2Api.get('/Season/current_all');
  const list = Array.isArray(data) ? data : [];
  const bundles = [];
  for (const s of list) {
    const id = String(s.season_id ?? s.seasonId ?? '');
    if (!id) continue;
    const label =
      (s.competition_name && String(s.competition_name).trim()) ||
      (s.season_name && String(s.season_name).trim()) ||
      'Saison';
    bundles.push({ id, label, rows: flattenSeasonCurrentToGridRows(s) });
  }
  return bundles;
}

/**
 * GET /Season/for_season — payload complet (boxes + matchs) d'UNE saison précise, quel que soit
 * son statut (active ou terminée) — utilisé pour réafficher à la demande une ancienne saison qui
 * n'apparaît pas dans /Season/current_all (actives uniquement).
 * @param {string} seasonId
 * @returns {Promise<{ id: string, label: string, rows: object[] } | null>}
 */
export async function fetchSeasonMatchBundleById(seasonId) {
  const sid = String(seasonId ?? '').trim();
  if (!sid) return null;
  const { data } = await v2Api.get('/Season/for_season', { params: { season_id: sid } });
  if (!data) return null;
  const id = String(data.season_id ?? data.seasonId ?? sid);
  const label =
    (data.competition_name && String(data.competition_name).trim()) ||
    (data.season_name && String(data.season_name).trim()) ||
    'Saison';
  return { id, label, rows: flattenSeasonCurrentToGridRows(data) };
}

/** Tous les matchs de toutes les saisons actives (pour synchro présence écran / poll). */
export async function getAllActiveSeasonMatchesFlat() {
  const bundles = await fetchActiveSeasonsMatchBundles();
  return bundles.flatMap((b) => b.rows);
}

/** Présence seule — poll ERP léger (évite current_all). */
export async function fetchActiveSeasonPresenceSnapshot() {
  const { data } = await v2Api.get('/Match/presence_snapshot');
  const raw = data?.matches ?? [];
  if (!Array.isArray(raw)) return [];
  return raw.map((m) => ({
    id: m.id ?? m.Id,
    player_a_present: m.player_a_present ?? m.playerAPresent,
    player_b_present: m.player_b_present ?? m.playerBPresent,
  }));
}

/**
 * GET /Season/current/matches
 * @returns {Promise<{ season: { id: string, name: string } | null, matches: object[] }>}
 */
export async function getPendingDelayMatches(seasonId) {
  const params = seasonId ? { season_id: seasonId } : undefined;
  const { data } = await v2Api.get('/Match/pending_delay_matches', { params });
  const raw = data?.matches ?? [];
  if (!Array.isArray(raw)) return [];
  return raw.map((m) => normalizeMatchForScreen(m));
}

export async function getCurrentSeasonMatches() {
  const path = '/Season/current/matches';
  const url = `${API_ROOT}${path}`;

  console.group(LOG, 'GET', path);
  console.log('baseURL', API_ROOT);
  console.log('URL complète', url);

  try {
    const response = await v2Api.get(path);
    const { data, status } = response;

    console.log('réponse HTTP', status);
    console.log('clés de data', data && typeof data === 'object' ? Object.keys(data) : typeof data);

    const sid = data?.season_id ?? data?.seasonId;
    const name = data?.season_name ?? data?.seasonName ?? 'Saison';
    const raw = data?.matches ?? [];

    console.log('season_id', sid ?? '(absent)');
    console.log('season_name', name);
    console.log('matches (brut) longueur', Array.isArray(raw) ? raw.length : `pas un tableau (${typeof raw})`);

    if (!Array.isArray(raw)) {
      console.warn('Attendu: data.matches = tableau. Reçu:', raw);
    }

    let matches = [];
    try {
      matches = raw.map((m, i) => {
        try {
          return normalizeMatchForScreen(m);
        } catch (rowErr) {
          console.warn('normalisation ligne', i, m, rowErr);
          throw rowErr;
        }
      });
    } catch (mapErr) {
      console.error('échec normalisation des matchs', mapErr);
      console.groupEnd();
      return { season: null, matches: [] };
    }

    const result = {
      season: sid ? { id: String(sid), name } : null,
      matches,
    };
    console.log('résultat', { saison: result.season, nbMatchs: matches.length });
    console.groupEnd();
    return result;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      console.error('erreur Axios', {
        message: err.message,
        code: err.code,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
      });
    } else {
      console.error('erreur (non-Axios)', err);
    }
    console.groupEnd();
    return { season: null, matches: [] };
  }
}

/**
 * POST /Match/update_presence — présence joueur A et/ou B (champs absents = inchangés côté API).
 */
export async function updateMatchPresence(matchId, patch) {
  const path = '/Match/update_presence';
  const payload = {
    match_id: String(matchId),
    ...patch,
  };
  try {
    const { data } = await v2Api.post(path, payload);
    return normalizeMatchForScreen(data);
  } catch (err) {
    const url = `${v2Api.defaults.baseURL ?? ''}${path}`;
    if (axios.isAxiosError(err)) {
      console.error(LOG, 'update_presence échoué', {
        url,
        status: err.response?.status,
        data: err.response?.data,
        payload,
      });
    } else {
      console.error(LOG, 'update_presence (non-Axios)', err, { url, payload });
    }
    throw err;
  }
}

/**
 * POST /Match/update_scores — unités (jeux/sets) gagnées (score_a / score_b), validées par le moteur de score de
 * l'API selon le format effectif du match. Détail facultatif : `units` ([{ side1, side2, tiebreak_side1?,
 * tiebreak_side2? }], envoyé quand il est saisi — score_a / score_b doivent alors valoir les unités gagnées) ou
 * `fullscore` (format squash « 11-5;9-11 »). Sans détail, le fullscore existant n'est pas modifié.
 * Refus : 400 `{ error: 'invalid_score', score_errors: [{ code, unit_index }] }` ou `{ error: 'score_mismatch' }`
 * (voir `apiScoreErrorMessage` dans utils/scoringEngine).
 * @returns {Promise<object>} MatchDto normalisé
 */
export async function updateMatchScores(matchId, scoreA, scoreB, { units = null, fullscore = null } = {}) {
  const path = '/Match/update_scores';
  const payload = {
    match_id: String(matchId),
    score_a: scoreA,
    score_b: scoreB,
  };
  if (Array.isArray(units) && units.length > 0) payload.units = units;
  else if (fullscore) payload.fullscore = fullscore;
  try {
    const { data, status } = await v2Api.post(path, payload);
    if (data == null) {
      console.warn(LOG, 'update_scores: réponse vide', status);
    }
    return normalizeMatchForScreen(data);
  } catch (err) {
    const url = `${v2Api.defaults.baseURL ?? ''}${path}`;
    if (axios.isAxiosError(err)) {
      console.error(LOG, 'update_scores échoué', {
        url,
        status: err.response?.status,
        data: err.response?.data,
        payload,
      });
    } else {
      console.error(LOG, 'update_scores (non-Axios)', err, { url, payload });
    }
    throw err;
  }
}

/**
 * Heure prévue d'un match → API. Convention : Match.scheduled_at est stocké en HEURE DU CLUB (Bruxelles),
 * relu tel quel par tous les clients. On envoie donc l'heure murale saisie (composantes locales du navigateur,
 * l'admin est au club) étiquetée « Z », que l'API garde telle quelle (MatchService.UpdateScheduleAsync).
 * Remplace l'ancien « toISOString() + 2 h » fixe, juste en heure d'été seulement : à partir du passage à
 * l'heure d'hiver (UTC+1), un match reprogrammé à 19:00 était enregistré à 20:00.
 */
export function scheduleIsoForApi(scheduledAtIso) {
  const d = new Date(scheduledAtIso);
  if (!Number.isFinite(d.getTime())) return scheduledAtIso;
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}:00.000Z`;
}

/**
 * @param {string|number} matchId
 * @param {string} scheduledAtIso ISO 8601 (ex. toISOString())
 */
export async function updateMatchSchedule(matchId, scheduledAtIso) {
  const path = '/Match/update_schedule';
  const payload = {
    match_id: String(matchId),
    scheduled_at: scheduleIsoForApi(scheduledAtIso),
  };
  const { data } = await v2Api.post(path, payload);
  return normalizeMatchForScreen(data);
}

/** `sport` (code catalogue, optionnel) : terrain de ce sport (`?sport=`) ; absent = comportement historique. */
export async function getLastWinnerByTerrain(terrainNumber, sport) {
  const n = Number(terrainNumber);
  if (!Number.isFinite(n) || n <= 0) return null;
  const code = String(sport ?? '').trim();
  const { data } = await v2Api.get(
    `/Match/last_winner_by_terrain/${encodeURIComponent(String(n))}`,
    code ? { params: { sport: code } } : undefined
  );
  return data?.winner ?? null;
}

export async function getHeadToHead(playerId1, playerId2) {
  const a = String(playerId1 ?? '').trim();
  const b = String(playerId2 ?? '').trim();
  if (!a || !b) return null;
  const { data } = await v2Api.get('/Match/head_to_head', {
    params: { player_id_1: a, player_id_2: b },
  });
  return data ?? null;
}

export async function startMatch(matchId, terrainNumber, refereeId) {
  const path = '/Match/start_match';
  const payload = {
    match_id: String(matchId),
    terrain_number: Number(terrainNumber),
    referee_id: refereeId != null && String(refereeId).trim() !== '' ? String(refereeId) : '',
  };
  const { data } = await v2Api.post(path, payload);
  return normalizeMatchForScreen(data);
}

/**
 * Match déjà en cours : met à jour terrain + arbitre.
 * @param {boolean} [clearReferee] Si true, retire l’arbitre (à utiliser quand l’utilisateur a vidé le champ alors qu’il y en avait un).
 */
export async function updateRunningMatchSetup(matchId, terrainNumber, refereeId, clearReferee = false) {
  const payload = {
    match_id: String(matchId),
    terrain_number: Number(terrainNumber),
    referee_id: refereeId != null && String(refereeId).trim() !== '' ? String(refereeId) : '',
    ...(clearReferee ? { clear_referee: true } : {}),
  };
  const { data } = await v2Api.post('/Match/update_running_setup', payload);
  return normalizeMatchForScreen(data);
}

export async function stopMatch(matchId) {
  const path = '/Match/stop_match';
  const { data } = await v2Api.post(path, { match_id: String(matchId) });
  return normalizeMatchForScreen(data);
}

/** Annule le résultat d'un match déjà joué (score effacé, retour à "pending") — refusé si le tableau
 * a déjà avancé plus loin à partir de ce résultat (voir MATCH_UNDO_ERRORS côté appelant). */
export async function undoMatchResult(matchId) {
  const path = '/Match/undo_result';
  const { data } = await v2Api.post(path, { match_id: String(matchId) });
  return normalizeMatchForScreen(data);
}

/** @param {'injury' | 'noshow' | 'delay'} incidentType */
export async function applyMatchIncident(matchId, playerId, incidentType) {
  const path = '/Match/apply_incident';
  const { data } = await v2Api.post(path, {
    match_id: String(matchId),
    player_id: String(playerId),
    incident_type: incidentType,
  });
  return normalizeMatchForScreen(data);
}

/** @param {'injury' | 'noshow' | 'delay'} incidentType */
export async function clearMatchIncident(matchId, incidentType) {
  const { data } = await v2Api.post('/Match/clear_incident', {
    match_id: String(matchId),
    incident_type: incidentType,
  });
  return normalizeMatchForScreen(data);
}

export async function recalculateLeaguePointsFromScores(seasonId) {
  const body = seasonId ? { season_id: String(seasonId) } : {};
  const { data } = await v2Api.post('/Match/recalculate_points_from_scores', body);
  return data;
}

/** POST /Match/generate — supprime les matchs existants puis génère ceux de la saison (round-robin) à partir de sa date de début. */
export async function generateMatchesForSeason(seasonId) {
  const { data } = await v2Api.post('/Match/generate', JSON.stringify(String(seasonId)), {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}

// ── Arbitrage live multi-sport (lot 9, docs/MULTISPORT.md « Arbitrage configurable ») ──────────────────────

/** POST /Match/get_match_by_id — MatchDto complet (live_referee_enabled, referee_profile, score_json…). */
export async function getMatchById(matchId) {
  const { data } = await v2Api.post('/Match/get_match_by_id', { match_id: String(matchId) });
  return data ? normalizeMatchForScreen(data) : null;
}

/**
 * POST /Match/update_live_score — `scoreJson` = journal COMPLET (chaîne JSON `score_json` v1, voir
 * utils/liveScoreLog.js `buildScoreLog`), rejoué par l'API avec le profil du sport. Renvoie le MatchDto à jour.
 * Refus 400 : `live_referee_disabled`, `invalid_score_json`, `unsupported_version`, `profile_mismatch`,
 * `unsupported_profile`, `invalid_score_log` (`details.code`, `details.event_index`).
 */
export async function updateLiveScore(matchId, scoreJson) {
  const { data } = await v2Api.post('/Match/update_live_score', { match_id: String(matchId), score_json: scoreJson });
  return data ? normalizeMatchForScreen(data) : null;
}

/** POST /Match/history — journal du match (API docs/MATCH_HISTORY.md), du plus ancien au plus récent. */
export async function getMatchHistory(matchId) {
  const { data } = await v2Api.post('/Match/history', { match_id: String(matchId) });
  return Array.isArray(data?.items) ? data.items : [];
}

// ── Édition admin brute (ERP « Détail du match », rôle administrateur uniquement) ──────────────

/** POST /Match/admin_get_match_detail — toutes les colonnes du match + libellés résolus. */
export async function adminGetMatchDetail(matchId) {
  const { data } = await v2Api.post('/Match/admin_get_match_detail', { match_id: String(matchId) });
  return data;
}

/** POST /Match/admin_match_options — sports, formats de scoring, saisons, box, statuts. */
export async function adminGetMatchOptions() {
  const { data } = await v2Api.post('/Match/admin_match_options', {});
  return data;
}

/**
 * POST /Match/admin_update_match — PATCH : n'envoyer QUE les champs modifiés (null = vider la colonne).
 * @param {string} matchId
 * @param {Record<string, unknown>} fields clés snake_case des colonnes du match
 * @param {{ recalculatePoints?: boolean }} [opts]
 * @returns {Promise<object>} détail rafraîchi (même forme que adminGetMatchDetail)
 */
export async function adminUpdateMatch(matchId, fields, { recalculatePoints = false } = {}) {
  const { data } = await v2Api.post('/Match/admin_update_match', {
    match_id: String(matchId),
    fields: fields || {},
    recalculate_points: Boolean(recalculatePoints),
  });
  return data;
}

/** POST /Match/admin_create_match — sport_id, player_a_id, player_b_id obligatoires ; renvoie le détail créé. */
export async function adminCreateMatch(fields, { recalculatePoints = false } = {}) {
  const { data } = await v2Api.post('/Match/admin_create_match', {
    fields: fields || {},
    recalculate_points: Boolean(recalculatePoints),
  });
  return data;
}

export const matchesService = {
  getPendingDelayMatches,

  async getBySeasons(seasonIds) {
    if (!Array.isArray(seasonIds) || seasonIds.length === 0) return { data: [] };
    const bundles = await fetchActiveSeasonsMatchBundles();
    const want = new Set(seasonIds.map((x) => String(x)));
    const data = bundles.flatMap((b) => (want.has(b.id) ? b.rows : []));
    return { data };
  },

  getCurrentSeasonMatches,
  updateMatchPresence,
  updateMatchScores,
  updateMatchSchedule,
  getLastWinnerByTerrain,
  getHeadToHead,
  startMatch,
  updateRunningMatchSetup,
  stopMatch,
  undoMatchResult,
  applyMatchIncident,
  clearMatchIncident,
  recalculateLeaguePointsFromScores,
  adminGetMatchDetail,
  adminGetMatchOptions,
  adminUpdateMatch,
  adminCreateMatch,
  getMatchById,
  updateLiveScore,
};
